module.exports = __webpack_public_path__ + "img/pc-cn-3.3fc3a746.gif";